/**
 * WhatsAppPage — Phase 3.
 *
 * Replaces the "Coming Soon" hardcode that was here while the Cloud
 * API was being built. Now renders the live inbox so /whatsapp lands
 * on the conversation list + message view.
 *
 * Permission + FeatureGate are applied by the App.js Route wrapper
 * (whatsapp:view, marketing.whatsapp). The inbox itself is wrapped in
 * Shell + FeatureGate inside WhatsAppInbox, so this page is just a
 * thin re-export — no double-wrapping.
 */
import React from 'react';
import WhatsAppInbox from '../WhatsAppInbox';

function WhatsAppPage() {
  return <WhatsAppInbox />;
}

export default WhatsAppPage;
